import useTranslation from '@/utils/hooks/translation/useTranslation';

// Types
import type { MutateLibraryMediaType } from '@/utils/hooks/swr/useLibraryMedia/types/types';

import Button from '@/components/base/Button';
import Dropdown from '@/components/base/Dropdown';
// Components
import Icon from '@/components/base/Icon';
// Layouts
import { PageHeaderRecap } from '@/components/layouts/LayoutPlatform/components/PageHeaderRecap';
import ButtonIcons from '@/components/layouts/LayoutPlatform/components/PageHeaderRecap/ButtonIcons';
import MediaUpload from '@/components/pages/media/components/MediaUpload';

type HeaderMediaLibraryProps = {
    mutateLibraryMedia: MutateLibraryMediaType;
    toggleFilters: () => void;
    isFiltersOpen: boolean;
};

export function HeaderMediaLibrary({
    mutateLibraryMedia,
    isFiltersOpen,
    toggleFilters
}: HeaderMediaLibraryProps) {
    const { t } = useTranslation('media');

    return (
        <PageHeaderRecap title={t('media_title')}>
            {({ isSticky }) => {
                return (
                    <div className="flex items-center gap-5">
                        <MediaUpload
                            mutateLibraryMedia={mutateLibraryMedia}
                            button={
                                <Dropdown.Button
                                    as="div"
                                    className="w-full rounded-full focus:ring-offset-0">
                                    <Button
                                        size={isSticky ? 'sm' : 'md'}
                                        className="create-new-add">
                                        <Icon icon="media-upload" className="mr-3" />
                                        {t('add_media_btn')}
                                    </Button>
                                </Dropdown.Button>
                            }
                        />
                        <ButtonIcons
                            actions={[
                                {
                                    id: 'filter',
                                    icon: 'filter',
                                    isActive: isFiltersOpen,
                                    tooltip: t('myprofile:filters'),
                                    onClick: toggleFilters,
                                    'data-testid': 'toggle-filters'
                                }
                            ]}
                            smaller={isSticky}
                        />
                    </div>
                );
            }}
        </PageHeaderRecap>
    );
}
